module.exports = __webpack_public_path__ + "static/media/special-offers-light@3x.e918e576.png";